import React from "react";

export function Card({ className = "", children, ...props }) {
  return (
    <section className={`np-card ${className}`.trim()} {...props}>
      {children}
    </section>
  );
}

export function CardHeader({ className = "", children, ...props }) {
  return (
    <header className={`np-card__header ${className}`.trim()} {...props}>
      {children}
    </header>
  );
}

export function CardBody({ className = "", children, ...props }) {
  return (
    <div className={`np-card__body ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ className = "", children, ...props }) {
  return (
    <footer className={`np-card__footer ${className}`.trim()} {...props}>
      {children}
    </footer>
  );
}
